module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_big.29fbbd64.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_big.jpg
// module id = 2975
// module chunks = 11